// extracted by mini-css-extract-plugin
export var full = "loader-module--full--635cb";
export var ldsRipple = "loader-module--lds-ripple--9d2de";
export var ldsRipple__wrapper = "loader-module--lds-ripple__wrapper--6df6f";
export var little = "loader-module--little--62a1c";
export var loadingText = "loader-module--loading-text--7c944";
export var noBg = "loader-module--no-bg--b3918";